import InstanceListManager from '../modules/InstanceListManager';

class BaseHandler {
  constructor(){};

  getElementsByDataInit = (selector, container = document) => {
    let nodeList = container.querySelectorAll(`[data-init~="${selector}"]`);

    
    return nodeList;
  }

  createUniqueID = (suffix) => `${Math.random().toString(36).substr(2, 9)}_${suffix || ""}`;

  createInstanceListByName = (name) => {
    return new InstanceListManager(name);
  }

  dismantleAllAndDeleteInstanceList = () => {
    // Get reference to global instance objects that holds all these elements
    // this.instanceList is defined in the handler that extends this one

    // Remove references to elements previously instantiated
    this.elements = [];

    if(this.instanceList !== null && this.instanceList !== undefined){
      let activeInstanceList = this.instanceList.getGlobalList();

      Object.keys(activeInstanceList).forEach((key, index) => {
        let element = activeInstanceList[key];
        element.dismantle();
        delete activeInstanceList[key];
      });

      delete window.INSTANCES[this.instanceList.name];

      // Reset instance list to null so on a re-init it doesn't think elements already exist.
      this.instanceList = null;
    }
  }

  dismantleByID = (id) => {
    let activeInstanceList = this.instanceList.getGlobalList();
    let element = activeInstanceList[id];
    element.dismantle();
    delete activeInstanceList[id];
  }
}

export default BaseHandler;
